import React from 'react';

import {RISK_LEVEL_STOP} from '../../utils/cybersecurityScoring';
import './riskChip.scss';

export function RiskChip({value, level}) {
  if (value === null || value === undefined) {
    return (
      <span className="risk-chip risk-chip--unscored">
        Not Assessed
      </span>
    );
  }

  const stop = RISK_LEVEL_STOP[value];

  return (
    <span className="risk-chip" data-stop={stop}>
      <span className="risk-chip__value">{value}</span>
      <span className="risk-chip__level">{level}</span>
    </span>
  );
}

export function SeverityBadge({label, stop}) {
  if (!label) {
    return <span className="severity-badge severity-badge--unset">Not Assessed</span>;
  }

  return (
    <span className="severity-badge" data-stop={stop}>
      {label}
    </span>
  );
}
